import React, { useEffect, useState } from 'react';
import { Box, Typography, Button, Link } from '@material-ui/core';
import CustomModal from '../../eir-porting/CustomModal/CustomModal';
import useStyles from './style';
import { useWindowDimension } from '../../../hooks/windowDimensions';
import EirButton from '../../../theme/EirButton';
import brand from '../images/Brand.png';
import eSimIcon from '../images/eSIM.png';
import recycle from '../images/icon-park-outline_recycling.png';

const EsimInfoModal = () => {
    const classes = useStyles();
    const [open, setOpenModal] = useState(false);
    const backArrowAction = () => {
        setOpenModal(!open);
    };
    const [width, height] = useWindowDimension();
    const [cta1, setCTA1] = useState({ text: '', action: () => {}, disable: false });
    const [cta2, setCTA2] = useState({ text: '', action: () => {}, disable: false });

    const handleOpen = () => {
        setOpenModal(true);
    };

    return (
        <Box id='sim-replacement'>
            <Link component='a' onClick={handleOpen} className={classes.esimInfoLink} aria-label='eSIM explanation will open in pop-up window' href='#' role='link'>
                What is an eSIM?
            </Link>
            <CustomModal
                open={open}
                header={{
                    text: 'What is an eSIM?',
                    center: true,
                }}
                cta1={cta1}
                cta2={cta2}
            >
                <Box className={classes.modalContent}>
                    <Typography variant='body1' align='center' className={classes.headingText}>
                        An eSIM or an “embedded SIM” is built into the device. They work exactly the
                        same way as physical SIM and come with additional benefits. With an eSIM
                        you’re not just getting smarter technology; you’re getting a more connected,
                        hassle-free experience
                    </Typography>

                    <Box className={classes.infoRow}>
                        <Box component='img' src={recycle} alt='' className={classes.icon} />
                        <Typography variant='body1' className={classes.descriptionText}>
                            <Typography
                                variant='h6'
                                component='span'
                                className={classes.inlineHeading}
                            >
                                More environmentally friendly:
                            </Typography>{' '}
                            An eSIM eliminates the need for plastic SIM cards, reducing waste.
                        </Typography>
                    </Box>

                    <Box className={classes.infoRow}>
                        <Box component='img' src={brand} alt='' className={classes.icon} />
                        <Typography variant='body1' className={classes.descriptionText}>
                            <Typography
                                variant='h6'
                                component='span'
                                className={classes.inlineHeading}
                            >
                                Multiple eSIMs:
                            </Typography>{' '}
                            Manage both personal and work numbers seamlessly on the same phone.
                        </Typography>
                    </Box>

                    <Box className={classes.infoRow}>
                        <Box component='img' src={eSimIcon} alt='' className={classes.icon} />
                        <Typography variant='body1' className={classes.descriptionText}>
                            <Typography
                                variant='h6'
                                component='span'
                                className={classes.inlineHeading}
                            >
                                Convenience:
                            </Typography>{' '}
                            If your phone is lost or stolen, you can remotely manage or deactivate
                            your eSIM.
                        </Typography>
                    </Box>
                    <Box
                        style={{
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            flexDirection: 'column',
                            marginTop: width < 600 ? '16.41px' : '24px',
                        }}
                    >
                        {width < 600 ? (
                            <EirButton
                                onClick={backArrowAction}
                                variants='primaryButtonMedium'
                                style={{ padding: '0.5rem 2.5rem', width: '100%' }}
                                aria-lable='close-pop-up window'
                                role='button'
                            >
                                Close
                            </EirButton>
                        ) : (
                            <EirButton
                                onClick={backArrowAction}
                                variants='primaryButtonMedium'
                                style={{ padding: '0.5rem 1.813rem' }}
                                aria-lable='close-pop-up window'
                                role='button'
                            >
                                Close
                            </EirButton>
                        )}
                    </Box>
                </Box>
            </CustomModal>
        </Box>
    );
};

export default EsimInfoModal;
